import { useRouter } from '@uirouter/react';
import { useImmerAtom } from 'jotai-immer';
import { ROUTE_LIST } from '../../payor_const';
import { pageStateAtom } from '../payor_edit_atoms';
import { PageStoreHook, PayorEditPageState } from '../payor_edit_types';
import useNgContext from '../../../../core/services/useNgContext';
import { useCallback, useEffect } from 'react';
import utilSvc from '../../../../core/utilSvc';

export const usePayorEditStore = (): PageStoreHook<PayorEditPageState> => {
    const router = useRouter();
    const [state, setState] = useImmerAtom(pageStateAtom);

    const ngContext = useNgContext();

    const setEditStatus = useCallback(
        (canEdit: boolean) => {
            setState(draft => ({ ...draft, canEdit }));
        },
        [setState],
    );

    useEffect(() => {
        /** Copied over from payor.edit.js */
        const canEdit = utilSvc.user.hasFeature(ngContext.User, 'admin.payor.edit');
        setEditStatus(canEdit);
    }, [ngContext, setEditStatus]);

    const cancelEdit = useCallback((): void => {
        router.stateService.go(ROUTE_LIST);
    }, [router.stateService]);

    return {
        state,
        setEditStatus,
        cancelEdit,
    };
};
